import { createPortal } from "react-dom";
import type { ReactNode } from "react";

interface ModalGenericProps {
  onClose: () => void;
  children: ReactNode;
  size?: string;
  styleRounded?: string;
  overlayClassName?: string;
}

export function ModalGeneric({
  onClose,
  children,
  size,
  styleRounded = "rounded-lg",
  overlayClassName = "z-30",
}: ModalGenericProps) {
  const modalContent = (
    <div
      className={`fixed inset-0 bg-black !bg-opacity-10 flex justify-center items-center ${overlayClassName}`}
      onClick={onClose}
    >
      <div
        className={`bg-white ${styleRounded} p-6 mx-4 animate__animated animate__zoomIn animate__faster ${size}`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
}

export function ModalGenericJob({ children, size }: any) {
  const modalContent = (
    <div className="fixed inset-0 bg-black !bg-opacity-10 flex justify-center items-center z-30">
      <div
        className={`bg-white rounded-lg p-6 mx-4 animate__animated animate__zoomIn animate__faster ${size}`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
}
